// import React from "react";
// import privacypolicylogo from "../../Assests/privacypolicylogo.svg";
// import privarcypolicylogotwo from "../../Assests/privarcypolicylogotwo.svg";
// import { Col, Row } from "antd";

// const sections = [
//   {
//     num: 1,
//     title: "Information We Collect",
//     lead: "We may collect the following types of information:",
//     items: [
//       "User Information: Name, email address, company name, and related contact details.",
//       "Vehicle Data: Vehicle Identification Number (VIN), license plate number, make, model, and year.",
//       "Driver Data: Name, driver's license number, and contact information. (with client consent)",
//       "Location Data: Real-time GPS location of vehicles (with consent).",
//       "Customer Data: Customer names and contact details (if entered into the App).",
//     ],
//   },
//   {
//     num: 2,
//     title: "How We Use Your Information",
//     lead: "We process collected data for the following purposes:",
//     items: [
//       "To provide and improve the App and its functionalities.",
//       "To track vehicles, optimize deliveries, and enhance operational efficiency.",
//       "To generate and deliver periodic reports to clients.",
//       "To communicate with you regarding product updates, promotions, and customer support.",
//       "To carry out marketing activities related to TrackRight (with consent).",
//       "To integrate with third-party services, such as telematics providers, ERP software for TrackRight AI and AI Cargo.",
//       "To comply with legal obligations and enforce contractual agreements.",
//     ],
//   },
//   {
//     num: 3,
//     title: "Legal Basis for Processing",
//     lead: "We process your data based on the following legal grounds:",
//     items: [
//       "Contractual necessity: to provide services under the client contract.",
//       "Consent: for location data collection and marketing communications.",
//       "Legitimate interests: to improve our services and ensure operational security.",
//       "Legal compliance: where required by law.",
//     ],
//   },
//   {
//     num: 4,
//     title: "Sharing Your Information",
//     lead: "We will not share your personal data with third parties except in the following cases:",
//     items: [
//       "Service Providers: We use trusted partners such as Amazon Web Services (AWS) for data hosting, ERP software for consignments, and telematics providers for telematics integration. These providers are contractually bound to protect your data.",
//       "Legal Obligations: We may disclose information if required by law or necessary to protect the rights, safety, or property of TrackRight or others.",
//     ],
//   },
// ];

// const styles = {
//   wrapper: {
//     fontFamily: "DM Sans",
//     fontSize: 15,
//     background: "#fff",
//     padding: "32px 48px",
//     lineHeight: 1.6,
//   },
//   section: { marginBottom: 28 },
//   heading: { fontSize: 15, fontWeight: "bold", marginBottom: 6 },
//   lead: { marginBottom: 8 },
//   list: { listStyle: "none", padding: 0, margin: 0 },
//   listItem: { paddingLeft: 18, position: "relative", marginBottom: 2 },
//   bullet: { position: "absolute", left: 4, top: 0 },
// };

// export default function PrivacyPolicee() {
//   return (
//     <>
//       <img
//         src={privarcypolicylogotwo}
//         alt="Privacy Policy"
//         style={{ display: "block", margin: "0 auto 24px" }}
//       />
//       <Row>
//         <Col xl={3}></Col>
//         <Col xl={15}>
//           <div style={styles.wrapper}>
//             {sections.map((sec) => (
//               <div key={sec.num} style={styles.section}>
//                 <h2 style={styles.heading}>
//                   {sec.num}. {sec.title}
//                 </h2>
//                 <p style={styles.lead}>{sec.lead}</p>
//                 <ul style={styles.list}>
//                   {sec.items.map((item, i) => (
//                     <li key={i} style={styles.listItem}>
//                       <span style={styles.bullet}>•</span>
//                       {item}
//                     </li>
//                   ))}
//                 </ul>
//               </div>
//             ))}
//           </div>
//         </Col>
//         <Col xl={6}></Col>
//       </Row>
//     </>
//   );
// }

import React from "react";
import { Form, Input, Select, DatePicker, Checkbox, Button } from "antd";
import styled from "styled-components";

const { Option } = Select;

// --- STYLED COMPONENTS ---

const PageContainer = styled.div`
  display: flex;
  flex-direction: row;
  min-height: 100vh;
  width: 100%;

  @media (max-width: 992px) {
    flex-direction: column;
  }
`;

const LeftColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 40px 60px;

  background-image:
    radial-gradient(
      circle at 75% 20%,
      rgba(69, 148, 66, 0.15) 0%,
      transparent 45%
    ),
    radial-gradient(
      circle at 10% 85%,
      rgba(69, 148, 66, 0.12) 0%,
      transparent 40%
    );
  background-color: #ffffff;

  @media (max-width: 992px) {
    padding: 60px 24px 40px 24px;
    align-items: center;
    background-image: radial-gradient(
      circle at 50% 30%,
      rgba(49, 148, 66, 0.15) 0%,
      transparent 60%
    );
  }
`;
const ContentWrapper = styled.div`
  max-width: 500px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const TopSubheading = styled.h4`
  color: #0b3c5d;
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 24px;

  span {
    font-weight: 400;
  }
`;

const MainHeading = styled.h1`
  color: #2e7d32;
  font-size: 2.8rem;
  font-weight: 700;
  line-height: 1.3;
  margin-bottom: 40px;

  span {
    display: block;
    margin-bottom: 8px;
  }
`;

const FeatureList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const FeatureItem = styled.li`
  display: flex;
  align-items: center;
  color: #333333;
  font-size: 18px;
  font-weight: 500;

  &::before {
    content: "•";
    color: #333333;
    font-weight: bold;
    display: inline-block;
    width: 1.5em;
    margin-left: 4px;
  }
`;

// Right Side - Green Form Container
const RightColumn = styled.div`
  flex: 1;
  background-color: #279442;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px 60px;

  @media (max-width: 992px) {
    padding: 40px 24px 60px 24px;
  }
`;

const FormCard = styled.div`
  background-color: #ffffff;
  border-radius: 16px;
  padding: 40px;
  width: 100%;
  max-width: 620px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);

  @media (max-width: 576px) {
    padding: 24px;
  }
`;

// Pure Flexbox Grid Layout Elements for Form Rows/Cols
const FormRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  width: 100%;

  @media (max-width: 576px) {
    flex-direction: column;
    gap: 0;
  }
`;

const FormCol = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

// Ant Design Element Customizations via Styled Components
const StyledForm = styled(Form)`
  .ant-form-item-label > label {
    color: #555555;
    font-weight: 500;
  }

  .ant-input,
  .ant-select-selector,
  .ant-picker {
    border-radius: 6px !important;
    height: 42px !important;
    display: flex !important;
    align-items: center !important;
  }

  .ant-select-selector {
    padding: 0 11px !important;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #279442 !important;
    border-color: #279442 !important;
  }

  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: #279442 !important;
  }
`;

const SubmitButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
`;

const StyledButton = styled(Button)`
  width: auto !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  background-color: #279442 !important;
  border-color: #279442 !important;
  color: #ffffff !important;
  height: 42px !important;
  padding: 0 48px !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  font-size: 1rem !important;

  span {
    color: #ffffff !important;
  }

  &:hover {
    background-color: #1e7332 !important;
    border-color: #1e7332 !important;
    color: #ffffff !important;
  }

  &:focus {
    background-color: #279442 !important;
    border-color: #279442 !important;
    color: #ffffff !important;
  }
`;

const ConsentText = styled.span`
  color: #444444;
  font-size: 0.9rem;
  line-height: 1.4;

  a {
    color: #279442;
    text-decoration: underline;
    font-weight: 500;
  }
`;

// --- MAIN COMPONENT ---

export default function DemoBookingPage() {
  const [form] = Form.useForm();

  const onFinish = (values) => {
    console.log("Form Submitted successfully:", values);
  };

  return (
    <PageContainer>
      {/* Left Column - Marketing Copy */}
      <LeftColumn>
        <ContentWrapper>
          <TopSubheading>
            Unlock Your <span>Effective Management</span>
          </TopSubheading>

          <MainHeading>
            <span>Book Your</span>
            <span>Personalized</span>
            <span>Demo Today</span>
          </MainHeading>

          <FeatureList>
            <FeatureItem>Live Platform Walkthrough</FeatureItem>
            <FeatureItem>Interactive Q&A Session</FeatureItem>
            <FeatureItem>Personalized Recommendations</FeatureItem>
            <FeatureItem>Tailored Solutions</FeatureItem>
          </FeatureList>
        </ContentWrapper>
      </LeftColumn>

      {/* Right Column - Container & AntD Form */}
      <RightColumn>
        <FormCard>
          <StyledForm
            form={form}
            layout="vertical"
            onFinish={onFinish}
            requiredMark={false}
          >
            {/* Row 1: First Name & Last Name */}
            <FormRow>
              <FormCol>
                <Form.Item label="First Name" name="firstName">
                  <Input placeholder="Will" />
                </Form.Item>
              </FormCol>
              <FormCol>
                <Form.Item label="Last Name" name="lastName">
                  <Input placeholder="Smith" />
                </Form.Item>
              </FormCol>
            </FormRow>

            {/* Row 2: Email & Industry */}
            <FormRow>
              <FormCol>
                <Form.Item label="Email" name="email">
                  <Input type="email" placeholder="will@mail.com" />
                </Form.Item>
              </FormCol>
              <FormCol>
                <Form.Item label="Industry" name="industry">
                  <Input placeholder="Shipping" />
                </Form.Item>
              </FormCol>
            </FormRow>

            {/* Row 3: Country & Phone */}
            <FormRow>
              <FormCol>
                <Form.Item label="Country" name="country">
                  <Select placeholder="Kenya" defaultValue="Kenya">
                    <Option value="Kenya">Kenya</Option>
                    <Option value="United States">United States</Option>
                    <Option value="United Kingdom">United Kingdom</Option>
                  </Select>
                </Form.Item>
              </FormCol>
              <FormCol>
                <Form.Item label="Phone" name="phone">
                  <Input placeholder="9876543210" />
                </Form.Item>
              </FormCol>
            </FormRow>

            {/* Row 4: Company Name & Job Title */}
            <FormRow>
              <FormCol>
                <Form.Item label="Company name" name="companyName">
                  <Input placeholder="Demo" />
                </Form.Item>
              </FormCol>
              <FormCol>
                <Form.Item label="Job title" name="jobTitle">
                  <Input placeholder="Transport Manager" />
                </Form.Item>
              </FormCol>
            </FormRow>

            {/* Row 5: Number of Vehicles & Date Available */}
            <FormRow>
              <FormCol>
                <Form.Item label="Number of Vehicles" name="numberOfVehicles">
                  <Input placeholder="50" />
                </Form.Item>
              </FormCol>
              <FormCol>
                <Form.Item label="Date Available" name="dateAvailable">
                  <DatePicker
                    style={{ width: "100%" }}
                    placeholder="22nd Aug, 2026"
                  />
                </Form.Item>
              </FormCol>
            </FormRow>

            {/* Consent Checkbox */}
            <Form.Item
              name="agreement"
              valuePropName="checked"
              style={{ marginBottom: 8 }}
            >
              <Checkbox defaultChecked>
                <ConsentText>
                  By checking this box, you agree to the{" "}
                  <a href="#privacy">Privacy Policy</a> of TrackRight.
                </ConsentText>
              </Checkbox>
            </Form.Item>

            {/* Submit Button */}
            <SubmitButtonWrapper>
              <StyledButton type="primary" htmlType="submit">
                Submit
              </StyledButton>
            </SubmitButtonWrapper>
          </StyledForm>
        </FormCard>
      </RightColumn>
    </PageContainer>
  );
}
